import { Visa } from './Visa';
import { Mastercard } from './Mastercard';
import { Discover } from './Discover';
import { PayPal } from './PayPal';
import { Amex } from './Amex';
import { Afterpay } from './Afterpay';
import { MerchCredits } from './MerchCredits';
import { Ideal } from './Ideal';
import { Sofort } from './Sofort';
import { Klarna } from './Klarna';
import { Multibanco } from './Multibanco';
import { ApplePay } from './ApplePay';

/**
 * To create a new logo, follow this example for the payment method "SquidCoin"
 * 1. Create a file in this directory called SquidCoin.svg
 * 2. Copy/paste the logo SVG into that file
 *    - Note: most logos can be found at the following link, just replace "SquidCoin" with your payment method name: https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/SquidCoin.svg`
 * 3. In your command line, run `npx @svgr/cli src/components/shared/icons/paymentMethodLogos/SquidCoin.svg > src/components/shared/icons/paymentMethodLogos/SquidCoin.js`
 * 4. In your newly generated SquidCoin.js file, update the component name to be "SquidCoin" and add the following properties to the svg:
 *    - viewBox="x y w h" (find the values for x, y, w, h in the SVG you copied)
 *    - aria-hidden
 *    - data-testid="squidcoin-logo"
 * 5. Import your component into this file and add it to the list of exports
 * 6. Hooray! You now have a beautiful logo for SquidCoin!
 */
export default {
  Visa,
  Mastercard,
  Discover,
  PayPal,
  Amex,
  Afterpay,
  MerchCredits,
  Ideal,
  Sofort,
  Klarna,
  Multibanco,
  ApplePay,
};
